
class ImageManagerService {

  constructor($http, Upload, $q) {
    this.$http = $http;
    this.uploader = Upload
    this.$q = $q;
  }

  listImages() {
    return this.$http.get('/v5/reviewBuilder/images').then(response => response.data);
  }

  deleteImage(imageId) {
    return this.$http.delete('/v5/reviewBuilder/images/' + imageId)
  }

  uploadImage(file, minFileSizeBytes, maxFileSizeBytes) {
    // upload the thing
    let deferred = this.$q.defer();

    this.uploader.upload({
      url: '/v5/reviewBuilder/images/upload ',
      fields: {
        //  campaignId: $state.params.campaignId
        minFileSizeBytes,
        maxFileSizeBytes,
      },
      file: file
    }).then(function (data, status, headers, config) {
      deferred.resolve(data, status, headers, config);
    },function(data, status, headers, config){
      deferred.reject(data, status, headers, config);
    });

    return deferred.promise;
  }
}

angular.module('clientDashboardApp.reviewBuilder').factory('imageManagerService', function($http, Upload, $q) {
  return new ImageManagerService($http, Upload, $q);
})
